import { IVersionControl } from "../../../../interfaces/collection/ICollection";
//
// export const prodGetApiTemplate: IApiTemplate = {
//   name: 'prodGet',
//   desc: '正式表某一行',
//   required: false,
//   dbMethod: 'prodGet',
//   request: {},
//   response: {},
//   version: IVersionControl.Row,
//   hidden: true,
// };
export const publishApiTemplate = {
  name: 'publish',
  desc: '发布',
  required: false,
  dbMethod: 'publish',
  request: {},
  response: {},
  version: IVersionControl.Row,
  group: '管理接口'
};
export const prodCountApiTemplate = {
  name: 'prodCount',
  desc: '正式表总数',
  required: false,
  dbMethod: 'prodCount',
  request: {},
  response: {},
  version: IVersionControl.Row,
  hidden: true,
  group: '总数接口'
};
export const publishDeleteOpApiTemplate = {
  name: 'publishDeleteOp',
  desc: '发布删除',
  required: false,
  dbMethod: 'publishDeleteOp',
  request: {},
  response: {},
  version: IVersionControl.Row,
  group: '管理接口'
};
export const deleteOpCountApiTemplate = {
  name: 'deleteOpCount',
  desc: '删除操作总数',
  required: false,
  dbMethod: 'deleteOpCount',
  request: {},
  response: {},
  version: IVersionControl.Row,
  hidden: true,
  group: '总数接口'
};
export const deleteOpListApiTemplate = {
  name: 'deleteOpList',
  desc: '删除记录列表',
  required: false,
  dbMethod: 'deleteOpList',
  request: {},
  response: {},
  version: IVersionControl.Row,
  group: '列表接口'
};
export const historyListApiTemplate = {
  name: 'historyList',
  desc: '版本列表',
  required: false,
  dbMethod: 'historyList',
  request: {},
  response: {},
  version: IVersionControl.Row,
  group: '列表接口'
};
export const historyCountApiTemplate = {
  name: 'historyCount',
  desc: '版本总数',
  required: false,
  dbMethod: 'historyCount',
  request: {},
  response: {},
  version: IVersionControl.Row,
  hidden: true,
  group: '总数接口'
};
export const rollbackApiTemplate = {
  name: 'rollback',
  desc: '回滚',
  required: false,
  dbMethod: 'rollback',
  request: {},
  response: {},
  version: IVersionControl.Row,
  group: '管理接口'
};
export const unpublishedListApiTemplate = {
  name: 'unpublishedList',
  desc: '未发布列表',
  required: false,
  dbMethod: 'unpublishedList',
  request: {},
  response: {},
  version: IVersionControl.Row,
  hidden: true,
  group: '列表接口'
};
export const unpublishedCountTemplate = {
  name: 'unpublishedCount',
  desc: '未发布总数',
  required: false,
  dbMethod: 'unpublishedCount',
  request: {},
  response: {},
  version: IVersionControl.Row,
  hidden: true,
  group: '总数接口'
};
export const publishedListApiTemplate = {
  name: 'publishedList',
  desc: '已发布列表',
  required: false,
  dbMethod: 'publishedList',
  request: {},
  response: {},
  version: IVersionControl.Row,
  hidden: true,
  group: '列表接口'
};
export const publishedCountTemplate = {
  name: 'publishedCount',
  desc: '已发布总数',
  required: false,
  dbMethod: 'publishedCount',
  request: {},
  response: {},
  version: IVersionControl.Row,
  hidden: true,
  group: '总数接口'
};
export const getPublishStatusApiTemplate = {
  name: 'getPublishStatus',
  desc: '获取发布状态',
  required: false,
  dbMethod: 'getPublishStatus',
  request: {},
  response: {},
  version: IVersionControl.Row,
  hidden: true,
  group: '管理接口'
};
//# sourceMappingURL=rowVersion.js.map
